"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MANUAL_ORDER_TRAVEL_REPROCESS = void 0;
exports.MANUAL_ORDER_TRAVEL_REPROCESS = {
    CANNOT_BE_REPROCESSED: {
        usecase: "MANUAL_ORDER_TRAVEL_REPROCESS",
        type: "CANNOT_BE_REPROCESSED",
        messageLangMap: {
            "PT-BR": "Não é possível reprocessar as itens.",
        },
    },
    CANNOT_BE_AUTOMATICALLY_PROCESSED: {
        usecase: "MANUAL_ORDER_TRAVEL_REPROCESS",
        type: "CANNOT_BE_AUTOMATICALLY_PROCESSED",
        messageLangMap: {
            "PT-BR": "Não é possível prosseguir com o processamento automático.",
        },
    },
    USER_NOT_FOUND: {
        usecase: "MANUAL_ORDER_TRAVEL_REPROCESS",
        type: "USER_NOT_FOUND",
        messageLangMap: {
            "PT-BR": "Usuário do suporte não encontrado.",
        },
    },
    ITEMS_NOT_FOUND: {
        usecase: "MANUAL_ORDER_TRAVEL_REPROCESS",
        type: "ITEMS_NOT_FOUND",
        messageLangMap: {
            "PT-BR": "Não foi possível encontrar os itens para reprocessamento.",
        },
    },
};
